// src/utils/router.js

import VueRouter from "vue-router";

// 保存原始的 push 和 replace 方法
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

/**
 * 重写 router.push 方法
 * @param {string|Object} location - 要跳转的路由路径或路由对象
 * @param {Function} onComplete - 跳转成功的回调
 * @param {Function} onAbort - 跳转失败的回调
 * @returns {Promise} 返回一个 Promise
 */
VueRouter.prototype.push = function push(location, onComplete, onAbort) {
  // 判断当前路由是否与目标路由相同
  // this.currentRoute 是当前路由信息对象
  const isSameRoute =
    typeof location === "string"
      ? location === this.currentRoute.path
      : location.path && location.path === this.currentRoute.path;

  // 如果是相同路由，则返回一个已 resolve 的 Promise，避免报错
  if (isSameRoute) {
    return Promise.resolve();
  }

  // 否则，执行原始的 push 方法
  return originalPush.call(this, location, onComplete, onAbort);
};

/**
 * 重写 router.replace 方法 (与 push 逻辑类似)
 * @param {string|Object} location - 要跳转的路由路径或路由对象
 * @param {Function} onComplete - 跳转成功的回调
 * @param {Function} onAbort - 跳转失败的回调
 * @returns {Promise} 返回一个 Promise
 */
VueRouter.prototype.replace = function replace(location, onComplete, onAbort) {
  const isSameRoute =
    typeof location === "string"
      ? location === this.currentRoute.path
      : location.path && location.path === this.currentRoute.path;

  if (isSameRoute) {
    return Promise.resolve();
  }

  return originalReplace.call(this, location, onComplete, onAbort);
};

export default VueRouter;
